import { IUIRuntime } from '@cian/mf-registry/browser';

import {
  TGetChatbotFiltersMicrofrontendResponse,
  fetchGetChatbotFiltersMicrofrontend,
} from '../../repositories/mobile-filters-frontend';
import { IApplicationContext } from '../../types/applicationContext';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';
import { mapManifestForComponent } from '../../utils/mapManifestForComponent';

const DEFAULT_EXCEPTION_MESSAGE = 'Не удалось получить манифест микрофронта фильтров чатбота';

export async function fetchChatbotFiltersManifest(context: IApplicationContext) {
  const { httpApi, microfrontendsRegistry, logger, telemetry } = context;

  try {
    const { response, statusCode }: TGetChatbotFiltersMicrofrontendResponse = await fetchGetChatbotFiltersMicrofrontend(
      { httpApi },
    );

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_EXCEPTION_MESSAGE,
        statusCode,
      });
    }

    const chatbotFiltersMicrofrontendManifest = response.manifest;

    const image = microfrontendsRegistry.register(chatbotFiltersMicrofrontendManifest);

    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      const runtime = image.runtimeStrict<IUIRuntime>(chatbotFiltersMicrofrontendManifest.runtimeName);
      await runtime.ensure();
    }

    return mapManifestForComponent(chatbotFiltersMicrofrontendManifest);
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatbotGetFiltersMicrofrontendFail);

    const errorToLog = getGenericLikeError({
      domain: EExceptionDomain.Chatbot,
      error,
      message: DEFAULT_EXCEPTION_MESSAGE,
    });

    logger.error(errorToLog);

    return null;
  }
}
